import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import mathText from '../math_text.js'

const level = new Level({
    name: 'x_coord',
    dependencies: [
        'levels_maths/simple_length'
    ]
})


function common (q, a) {
    a.name = 'A'

    let geoScreen = q.addGeoScreen()
    geoScreen.addPoint(a)

    q.addText(mathText.pointX(a) + ' = ?')
    q.answer = a.x
}


level.addQuestion({
    generator: function (q) {
        common(q, {
            x: random.fairChoiceInt(1, 7, {name: 'x'}),
            y: random.fairChoiceInt(1, 4, {name: 'y'})
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            x: random.fairChoiceInt(-6, -1, {name: 'x'}),
            y: random.fairChoiceInt(1, 4, {name: 'y'})
        })

    }
})



export default level

